import strs from 'exports-loader?STRINGS!../js/strings.js';

Object.assign(strs.en,require('../js/strings.en.json'));
Object.assign(strs.de,require('../js/strings.de.json'));

export let language = 'en';
export const strings = Object.assign({},strs[language]);

export function get_language() {
 return language;
}
export function set_language(l) {
 if(!have_language(l)) throw new Error(`unknown language ${l}`);
 return Object.assign(strings,strs[language = l]);
}
export function have_language(l) {
 return !!strs[l];
}
export function _str(s) {
 return strings[s]||`ID: ${s}`;
}
